import { render, staticRenderFns } from "./EditContentSectionComponent.vue?vue&type=template&id=32462552&scoped=true"
import script from "./EditContentSectionComponent.vue?vue&type=script&lang=js"
export * from "./EditContentSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32462552",
  null
  
)

export default component.exports